import { CalendarTabs } from './CalendarTabs';

export type { TypeCalendarTabsProps, ExactasForm } from './types';
export default CalendarTabs;
